import { render, staticRenderFns } from "./DescargaPronostico.vue?vue&type=template&id=70d675d0&scoped=true"
import script from "./DescargaPronostico.vue?vue&type=script&lang=ts"
export * from "./DescargaPronostico.vue?vue&type=script&lang=ts"
import style0 from "./DescargaPronostico.vue?vue&type=style&index=0&id=70d675d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d675d0",
  null
  
)

export default component.exports